/**
 * Small presentational helpers used by MarketplaceSettings.
 * Extracted to keep the parent component focused on data orchestration.
 */
import { Switch } from "@/components/ui/switch";

export function ToggleRow({ icon: Icon, label, hint, val, onChange, testid }) {
  return (
    <div className="rounded-2xl border border-border p-3 flex items-start gap-3 bg-card/40">
      <span className="h-8 w-8 rounded-lg tb-chip-lavender grid place-items-center">
        <Icon className="h-3.5 w-3.5" />
      </span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium">{label}</p>
        {hint && <p className="text-[11px] text-muted-foreground mt-0.5">{hint}</p>}
      </div>
      <Switch checked={!!val} onCheckedChange={onChange} data-testid={testid} />
    </div>
  );
}

export function ModeChip({ label, val, onChange, testid }) {
  return (
    <button
      onClick={() => onChange(!val)}
      className={`rounded-2xl border p-3 text-left transition-all ${val ? "border-primary/60 bg-primary/10" : "border-border hover:border-primary/30"}`}
      data-testid={testid}
    >
      <p className="text-sm font-medium">{label}</p>
      <p className="text-[11px] text-muted-foreground mt-0.5">{val ? "Open to this mode" : "Tap to enable"}</p>
    </button>
  );
}

export function Field({ label, icon: Icon, children, testid }) {
  return (
    <label className="block" data-testid={testid}>
      <span className="text-[10px] uppercase tracking-[0.18em] font-semibold text-muted-foreground inline-flex items-center gap-1.5">
        {Icon && <Icon className="h-3 w-3" />} {label}
      </span>
      <span className="block mt-1.5">{children}</span>
    </label>
  );
}

export function DraftRow({ label, value, type = "text", onChange }) {
  return (
    <label className="block">
      <span className="text-[10px] uppercase tracking-[0.18em] font-semibold text-muted-foreground">{label}</span>
      <input className="tb-input mt-1" type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} />
    </label>
  );
}

export function DraftListRow({ label, value, onChange }) {
  const v = Array.isArray(value) ? value.join(", ") : "";
  return (
    <label className="block">
      <span className="text-[10px] uppercase tracking-[0.18em] font-semibold text-muted-foreground">{label}</span>
      <input className="tb-input mt-1" value={v} onChange={(e) => onChange(e.target.value.split(",").map((s) => s.trim()).filter(Boolean))} />
    </label>
  );
}
